var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailUnread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 20C3.1 20 2.75 19.85 2.45 19.55C2.15 19.25 2 18.9 2 18.5V5.5C2 5.1 2.15 4.75 2.45 4.45C2.75 4.15 3.1 4 3.5 4H14.35C14.3 4.25 14.2667 4.5 14.25 4.75C14.2333 5 14.2417 5.25 14.275 5.5H3.625L12 10.95L15.775 8.5C15.9417 8.65 16.1167 8.78894 16.3 8.91683C16.4833 9.04471 16.675 9.15577 16.875 9.25L12 12.45L3.5 6.875V18.5H20.5V9.5C20.7799 9.42028 21.0415 9.30869 21.2849 9.16523C21.5283 9.02174 21.7667 8.85833 22 8.675V18.5C22 18.9 21.85 19.25 21.55 19.55C21.25 19.85 20.9 20 20.5 20H3.5ZM18.9971 7.75C18.2324 7.75 17.5833 7.48235 17.05 6.94705C16.5167 6.41177 16.25 5.76177 16.25 4.99705C16.25 4.23235 16.5176 3.58333 17.0529 3.05C17.5882 2.51667 18.2382 2.25 19.003 2.25C19.7677 2.25 20.4167 2.51765 20.95 3.05295C21.4833 3.58823 21.75 4.23823 21.75 5.00295C21.75 5.76765 21.4824 6.41667 20.9471 6.95C20.4118 7.48333 19.7618 7.75 18.9971 7.75Z",
    fill: "#132353"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailUnread);
export default __webpack_public_path__ + "static/media/emailUnread.f476ba56bf01e7c0f8ad611baa24b485.svg";
export { ForwardRef as ReactComponent };